import { SpyneTrait } from "spyne";
import { PageDocsItem } from "components/pages/page-docs-item";

export class PageLoadDocsTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "pageLoad$";

    super(context, traitPrefix);
  }

  static pageLoad$HelloWorld() {
    return "Hello World";
  }

  static pageLoad$EnableScrollSpy() {
    this.props.disableScrollSpy = false;
  }

  static pageLoad$TrimLinebreaks(props = this.props) {
    const checkForLineBreak = (el) => {
      el.classList.add("check-for-empty");
      if (el.textContent === "\n") {
        el.textContent = "";
      }
    };

    //props.el$('.trim-linebreaks').arr.forEach(checkForLineBreak);
    //PageLoadDocsTraits.pageLoad$HideEmptyEl(props);
  }

  static pageLoad$HideEmptyEl(props = this.props) {
    const hideEmptyEl = (el) => {
      const isEmpty = el !== undefined && el.textContent.trim().length <= 0;
      el.classList.toggle("hide-empty-el", isEmpty);
    };

    props.el$(".check-for-empty").arr.forEach(hideEmptyEl);
  }

  static pageLoad$OnDocsItemChanged(e, scrollPageBool) {
    const { payload } = e;
    const pageId = payload?.pageId || payload?.routeData?.pageId;
    const { docsDataItem } = payload;
    const { srcEvent } = e?.srcElement;
    const { itemId } = docsDataItem ?? "";
    const checkToNavToItem = () => {
      // let itemEl$ = this.props.el$(`#${itemId}`);
      const isScrollPageEvent = scrollPageBool || srcEvent === "click";

      //console.log('page docs item ', {payload,pageId,isScrollPageEvent, docsDataItem, e, itemId});

      if (
        isScrollPageEvent === true &&
        pageId === "docs" &&
        itemId !== undefined
      ) {
        //console.log("ITEM IS ",itemEl$.el, {itemEl$})
        const offset = 160;
        // itemEl$.el.scrollIntoView();
        // this.props.disableScrollSpy = true;
        const scrollItem = () => {
          let itemEl$ = this.props.el$(`#${itemId}`);
          //console.log("SCROLL SCTION ",itemEl$.exists === true, itemEl$.el);
          if (itemEl$?.el?.scrollIntoView) {
            itemEl$.el.scrollIntoView({ block: "start" });
            window.scrollBy({ top: -offset });
            //console.log("SCROLLING INTO VIEW ",itemEl$.el);
            requestAnimationFrame(this.pageLoad$EnableScrollSpy.bind(this));
          }
        };
        requestAnimationFrame(scrollItem);
        //itemEl$.el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        //window.scrollBy({ top: -offset, behavior: 'smooth' });
        // window.setTimeout(this.enableScrollSpy.bind(this), 4000);
      }
    };

    requestAnimationFrame(checkToNavToItem);
  }

  static pageLoad$OnPageLoaded(e) {
    if (this.props.initLoaded === true) {
      this.disposeViewStream();
    } else {
      this.props.initLoaded = true;
      this.pageLoad$OnDocsItemChanged(e, true);
    }
  }

  static pageLoad$AddPageDocItems() {
    const { pageId } = this.props;
    const addPageItems = (data) => {
      const fn = () =>
        this.appendView(
          new PageDocsItem({ data, pageId }),
          ".page-docs-content",
        );
      requestAnimationFrame(fn);
    };

    this.props.data.docsContent.forEach(addPageItems);
  }
}
